"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const one_1 = require("remax/one");
const classnames_1 = __importDefault(require("classnames"));
const mask_1 = __importDefault(require("../mask"));
const icon_1 = __importDefault(require("../icon"));
const common_1 = require("../common");
const prefixCls = common_1.getPrefixCls('popup');
const Popup = (props) => {
    const { open = false, children, onClose, closeable, title, position = 'center', style, mask = true, square, curve, transparent, } = props;
    const handleClickMask = () => {
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    const classes = classnames_1.default({
        [`${prefixCls}-container`]: true,
        [`${prefixCls}-container-${position}`]: position,
        [`${prefixCls}-container-ease`]: curve === 'ease',
        [`${prefixCls}-container-square`]: square,
        [`${prefixCls}-container-active`]: open,
        [`${prefixCls}-container-transparent`]: transparent,
    });
    return (React.createElement(one_1.View, { className: prefixCls },
        React.createElement(one_1.View, { className: classes, style: style },
            title ? React.createElement(one_1.View, { className: `${prefixCls}-container-title` }, title) : null,
            children,
            closeable ? (React.createElement(one_1.View, { className: `${prefixCls}-container-close`, onTap: () => {
                    onClose === null || onClose === void 0 ? void 0 : onClose();
                } },
                React.createElement(icon_1.default, { type: "close", size: "40px", color: "#999" }))) : null),
        mask ? React.createElement(mask_1.default, { show: open, onTap: handleClickMask }) : null));
};
exports.default = Popup;
